export default [
  'Membro da comissão organizadora do prêmio Bocuse D`OR no Brasil.',
  'Jurado do prêmio cozinheiro do ano, da LXFactory (Portugal).',
  'Eleito 2x um dos melhores restaurantes do mundo, com o Cozinha Roccia - Guia Identitá Golose (Itália).',
  'Vencedor, com o Cozinha Roccia, do prêmio Melhor Restaurante do Nordeste em 2017 - Prazeres da Mesa.',
  'Eleito, com o Cozinha Roccia, um dos 10 melhores NOVOS restaurantes do Brasil em 2017 - Revista VIP.',
]
